'use client';

import { GameHubClient } from './GameHubClient';

export default function GameHubPage() {
  return <GameHubClient />;
}
